import {
  AfterViewInit,
  ChangeDetectorRef,
  Component,
  Input,
} from '@angular/core';
import { FormGroup } from '@angular/forms';
import { CKEditorModule } from '@ckeditor/ckeditor5-angular';
import { ClassicEditor } from 'ckeditor5';
import { ToastrService } from 'ngx-toastr';
import { CustomUploadAdapter } from '../../../pages/dashboard/EditorPlugins/CustomUploadAdapter';
import { EDITOR_CONFIG } from '../../constants/constants';
import { SharedService } from '../../services/shared.service';
import { SharedModule } from '../../shared.module';
@Component({
  selector: 'app-custom-editor',
  standalone: true,
  imports: [CKEditorModule, SharedModule],
  templateUrl: './custom-editor.component.html',
  styleUrl: './custom-editor.component.scss',
})
export class CustomEditorComponent implements AfterViewInit {
  @Input() form!: FormGroup;
  @Input() controlName: string = '';
  @Input() label: string = '';
  Editor = ClassicEditor;
  isLayoutReady = false;
  public config: any = {};

  constructor(
    private changeDetector: ChangeDetectorRef,
    private sharedService: SharedService,
    private toastr: ToastrService
  ) {}

  ngAfterViewInit(): void {
    this.config = EDITOR_CONFIG;
    this.isLayoutReady = true;
    this.changeDetector.detectChanges();
  }
  onReady(editor: any): void {
    editor.defaultConfig = {
      mediaEmbed: { previewsInData: true },
    };
    editor.plugins.get('FileRepository').createUploadAdapter = (
      loader: any
    ) => {
      return new CustomUploadAdapter(loader, this.sharedService, this.toastr);
    };
  }
}
